import React, { useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";
import HomePage from "./pages/homepage/HomePage";
import ContactPage from "./pages/contact/Contact";
import References from "./pages/references/References";
import Aboutus from "./pages/aboutus/Aboutus";
import Products from "./pages/products/Products";
import ProductDetail from "./pages/product-detail/ProductDetail";
import { FaWhatsapp } from "react-icons/fa";
import { ToastContainer } from "react-toastify";
import EmployeeInformation from "./pages/employeeInformation/EmployeeInformation";
import Cookie from "./pages/cookies/Cookie";
import Chatbot from "./pages/cookies/Chatbot";
import Visiter from "./pages/cookies/Visiter";
import Camera from "./pages/cookies/Camera";
import WhatsAppPrivacyPolicy from "./pages/cookies/whatsapp-privacy-policy";
import ContactFormInfo from "./pages/cookies/contact-form-info";
import NewsletterPrivacyPolicy from "./pages/cookies/newsletter-privacy-policy";
import CookieBanner from "./components/CookieBanner";

const App = () => {
  const [resetCat, setResetCat] = useState(false);

  return (
    <Router>
      <Header setResetCat={setResetCat} />
      <CookieBanner />
      <a
        rel="noreferrer noopener"
        href="https://wa.me/905447645462"
        target="_blank"
        className="fixed bottom-5 right-5 p-2 bg-green-500 rounded-full shadow-md z-[99999]"
      >
        <FaWhatsapp className="text-white" size={35} />
      </a>

      <ToastContainer />

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/iletisim" element={<ContactPage />} />
        <Route path="/referanslar" element={<References />} />
        <Route path="/hakkimizda" element={<Aboutus />} />
        <Route path="/cerez-aydinlatma-metni" element={<Cookie />} />
        <Route path="/ziyaretci-aydinlatma-metni" element={<Visiter />} />
        <Route path="/cctv-kamera-aydinlatma-metni" element={<Camera />} />

        <Route
          path="/e-bulten-aydinlatma-metni"
          element={<NewsletterPrivacyPolicy />}
        />

        <Route
          path="/iletisim-formu-aydinlatma-metni"
          element={<ContactFormInfo />}
        />
        <Route
          path="/whatsapp-destek-aydinlatma-metni"
          element={<WhatsAppPrivacyPolicy />}
        />
        <Route
          path="/whatsapp-chatbot-aydinlatma-metni"
          element={<Chatbot />}
        />
        <Route
          path="/calisan-adayi-aydinlatma-metni"
          element={<EmployeeInformation />}
        />
        <Route
          path="/urunler"
          element={<Products resetCat={resetCat} setResetCat={setResetCat} />}
        />
        <Route path="/urunler/urun-detay/:id" element={<ProductDetail />} />
      </Routes>
      <Footer />
    </Router>
  );
};

export default App;
